import { Field } from '@availity/form';
import React, { useEffect, useState } from 'react';

interface PercentageFieldProps {
    formKey: string;
    value: string;
    updateValue: (value: string) => void;
    includeDecimals?: boolean;
    decimalPoints?: number;
    className?: string;
    id?: string;
}

export const PercentageField = (props: PercentageFieldProps) => {
    const [value, setValue] = useState<string>('0');

    useEffect(() => {
        setValue(props.value ?? '0');
    }, [props]);

    const validate = (event: any, keyprop: string) => {
        if (props.includeDecimals)
            return validateWithDecimals(event, keyprop, props.decimalPoints);
        else return validateInts(event);
    };

    const validateInts = (event: any) => {
        if (
            !/[0-9]/.test(event.key) &&
            event.key != 'Backspace' &&
            event.key != 'ArrowRight' &&
            event.key != 'ArrowLeft' &&
            event.key != 'Tab'
        ) {
            return true;
        }
        return false;
    };

    const validateWithDecimals = (
        event: any,
        keyprop: string,
        maxDecimals: number
    ) => {
        const countDecimals = (x: string) => {
            const match = x.match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
            if (!match) return 0;
            return Math.max(
                0,
                (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0)
            );
        };

        const decimalCount = countDecimals(
            keyprop.toString().replace('%', '')
        );
        const isChangeAfterDot =
            (event.target as HTMLTextAreaElement).selectionStart >
            keyprop.toString().replace('%', '').length - 2;
        const isWithinDecimalLimit = decimalCount < maxDecimals;

        if (
            !/[0-9]/.test(event.key) &&
            event.key !== 'Backspace' &&
            event.key !== 'ArrowRight' &&
            event.key !== 'ArrowLeft' &&
            event.key !== 'Tab' &&
            (event.key !== '.' || keyprop.toString().includes('.'))
        ) {
            return true;
        }

        if (event.key === '.' && isWithinDecimalLimit && !isChangeAfterDot) {
            return true;
        }

        if (
            /[0-9]/.test(event.key) &&
            isChangeAfterDot &&
            !isWithinDecimalLimit
        ) {
            return true;
        }

        return false;
    };

    return (
        <Field
            type="text"
            name={props.formKey}
            id={props.id}
            className={props.className}
            value={value.toString().includes('%') ? value : value + '%'}
            min={1}
            max={100}
            onKeyDown={(event) => {
                if (validate(event, value)) {
                    event.preventDefault();
                }
            }}
            onChange={(event) => {
                let value = event.target.value;

                if (!event.target.value.includes('%')) {
                    value = event.target.value.slice(0, -1);
                }
                const resultValue = value.replace('%', '') + '%';
                props.updateValue(resultValue);
            }}></Field>
    );
};
